<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{title}}
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" mat-dialog-close><mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon></button>
    </div>
</div>

<div mat-dialog-content class="nova__dialog__content">
    <mat-form-field>
        <mat-label>{{selectTitle}}</mat-label>
            <mat-select [(ngModel)]="selection">
                @for(item of selectItems; track item.id) {
                    <mat-option [value]="item.id">
                        {{item.name}}
                    </mat-option>
                }
            </mat-select>
    </mat-form-field>
        
    <mat-dialog-actions class="nova__dialog__content__actions" align="end">
        <button mat-raised-button color="primary" (click)="close(true)" [disabled]="!selection">SAVE</button>
        <button mat-button color="default" (click)="close(false)">CANCEL</button>
    </mat-dialog-actions>
</div>
